export const useQueryArray = (query_value) => {
	return (`${query_value||''}`).split(",").filter(v => !!v);
};

export const useQueryString = (params: Record<string, string | string[]>) => {
	if(!params) return '';
	return Object.entries(params)
	  .map(([key, value]) => {
		if (Array.isArray(value)) {
		  return `${encodeURIComponent(key)}=${value.map(encodeURIComponent).join(',')}`;
		} else {
		  return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
		}
	  })
	  .join('&');
  };
